import { Page } from '@app/components/page/Page';
import { Group, useRouter } from '@mi-front/core';
import { AsyncView } from '@mi-front/ui';
import { useIntl } from 'react-intl';
import { useParams } from 'react-router-dom';
import { fetchGroup } from '../../../api';
import { GroupsBreadcrumbs } from '../header';
import { ConnGroupForm } from './form';

import { GroupIcon } from '@app/components/users/GroupIcon';
import { FormattedMessage } from 'react-intl';
interface Props {
  readonly data: {
    readonly group: Group;
  };
  readonly onSuccess: (data: Group) => void;
  readonly cancel: () => void;
}

export const AdminGroupsEditPageP = (p: Props) => {
  const { group } = p.data;
  const { $t } = useIntl();

  return (
    <Page
      data-cy="groups-edit-screen"
      htmlTitle={$t({
        id: 'modulesAdminLocaleEs.m.admin.groups.editScreen.title',
        defaultMessage: 'Editar grupo',
      })}
    >
      <Page.Header
        icon={<GroupIcon />}
        title={
          <>
            <FormattedMessage id="admin.groups.editScreen.title" defaultMessage="Editar grupo" />{' '}
            <span className="title-alt">{group.name}</span>
          </>
        }
        breadcrumbs={<GroupsBreadcrumbs activeText={group.name} />}
      />
      <Page.Content>
        <ConnGroupForm id={group.id} onSuccess={p.onSuccess} cancel={p.cancel} />
      </Page.Content>
    </Page>
  );
};

export function AdminGroupsEditPage() {
  const { id } = useParams<{ id: string }>();
  const { history } = useRouter();

  return (
    <AsyncView
      promiseFn={() => fetchGroup(id).then((group) => ({ group }))}
      loader={<FormattedMessage id="common.loadingEntity" defaultMessage="Cargando entidad" />}
    >
      {(pp) => (
        <AdminGroupsEditPageP
          {...pp}
          onSuccess={() => {
            history.push(`/admin/groups/${id}`);
          }}
          cancel={() => history.push(`/admin/groups/${id}`)}
        />
      )}
    </AsyncView>
  );
}
